import React from "react";
import { APP_ICON_FACEBOOK_PATH } from "../routes";
import AppIcon3Page from "./AppIcon3Page";

/**
 * Same 2×2 sliding tiles as the store app icon, with a transparent canvas.
 * Facebook rejects icons that have a white background.
 */
export default function AppIconFacebookPage() {
    return (
        <AppIcon3Page
            transparent
            routePath={APP_ICON_FACEBOOK_PATH}
            slug="app-icon-facebook"
            fileName="sliding-puzzle-quest-app-icon-facebook-512x512.png"
            frameId="sliding-app-icon-facebook"
        />
    );
}
